import { render, staticRenderFns } from "./ReservationModal.vue?vue&type=template&id=bf5b8fe0&scoped=true"
import script from "./ReservationModal.vue?vue&type=script&lang=js"
export * from "./ReservationModal.vue?vue&type=script&lang=js"
import style0 from "./ReservationModal.vue?vue&type=style&index=0&id=bf5b8fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b8fe0",
  null
  
)

export default component.exports